const initialState = {
  fetchingHabits: false, // Legacy - kept for compatibility but functionality moved to pendingActions module
  initialFetch: true,
  actionsQueue: [],
};

export default function queue(state = initialState, action) {
  console.log("queue reducer", action.type);
  let nextState = { ...state };
  switch (action.type) {
    case "FETCHING_HABITS":
      nextState.fetchingHabits = true; // Legacy compatibility
      console.log("queue reducer FETCHING_HABITS", nextState);
      break;
    case "FETCH_HABIT_SUCCESS":
    case "NOT_FETCHING_HABITS":
      nextState.fetchingHabits = false; // Legacy compatibility
      nextState.initialFetch = false;
      break;
    case "ADD_TO_QUEUE":
      nextState.actionsQueue = [...state.actionsQueue, action.action];
      break;
    case "CLEAR_QUEUE":
    case "LOGOUT":
      console.log("queue initialState");
      nextState.fetchingHabits = false; // Legacy compatibility
      nextState.initialFetch = true;
      nextState.actionsQueue = [];
      break;
    default:
      console.log("queue reducer default", state.fetchingHabits);
      return state;
      break;
  }
  console.log("queue reducer return", nextState.fetchingHabits);
  return nextState;
}
